/**
 * acequia.sync — headless, config-driven directory sync over WebDAV.
 *
 * WebDavSync's engine, extracted (projects/docs/2026/09/24/webdavsync-as-an-
 * acequia-js-capability-…). A saved WebDavSync configuration, with its two
 * servers resolved inline, is a call:
 *
 *   const plan = await acequia.sync.analyze(config)   // copies, deletes, skips, each with a reason
 *   await acequia.sync.apply(plan)                    // after the caller has looked, filtered, confirmed
 *   await acequia.sync.run(config)                    // both
 *
 * Runs in the browser, the service worker and Node: no DOM, no storage —
 * patterns are lists in the config, `fetch` is injectable.
 */
export { analyze, apply, run, testConnections, normalizeConfig, formatFileSize, DEFAULT_MAX_FILE_SIZE } from './engine.js'
export { SyncClient, HttpError } from './client.js'
export { parseMultistatus } from './davResponse.js'
export * as patterns from './patterns.js'
export { DEFAULT_EXCLUSIONS } from './patterns.js'
export { SYNC_TYPES, listTypes, applyType } from './types.js'
